export default __webpack_public_path__ + "dcd864a62d71d937d131419283e7b5a1.jpg";